import { useEffect } from "react";
import { Output } from "valibot";

import { useGlobalsContext } from "shared/hooks";

import { BotInfoSchema } from "./schemas";

function useBotInfoUpdates(botInfo: Output<typeof BotInfoSchema>) {
  const { setWidgetExpanded } = useGlobalsContext();

  useEffect(() => {
    if (botInfo.bot_info_config.is_open_on_initial_render) {
      setWidgetExpanded(true);
    }
  }, [setWidgetExpanded, botInfo.bot_info_config.is_open_on_initial_render]);

  return {};
}

export default useBotInfoUpdates;
